import React, { useContext, useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { PlansContext } from '../../../../../../context/plans/plansContext';
import { IMembersData } from '../../../../../../interfaces/businessData';
import { TRANSLATIONS_COLLABORATOR_STATUS_V3 } from '../../../../../../translations/collaborators';
import BdsLabelPill from '../../../../BdsActivityPill/BdsActivityPill';
import TruncatedText from '../../TruncatedText/TruncatedText';

interface CollaboratorsPlanProps {
  collaborator: IMembersData;
}

const CollaboratorsPlan = ({ collaborator }: CollaboratorsPlanProps) => {
  const [planName, setPlanName] = useState<string>();
  const { plans } = useContext(PlansContext);
  const { t } = useTranslation();

  useEffect(() => {
    const planId = collaborator.plans[0];
    const plan = plans.find((plan) => plan.id.toString() === planId);
    setPlanName(plan?.name);
  }, [plans, collaborator]);

  return (
    <div>
      {planName ? (
        <TruncatedText text={planName} maxWidth="240px" />
      ) : (
        <BdsLabelPill label={t(TRANSLATIONS_COLLABORATOR_STATUS_V3.pending)} variant="inverse" />
      )}
    </div>
  );
};

export default CollaboratorsPlan;
